import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';
import { formatDate } from '@angular/common';
import * as dayjs from 'dayjs';

export const PICK_FORMATS = {
  parse: {
    dateInput: 'LL'
  },
  display: {
    dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'MMMM',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY'
  }
}

@Injectable()
export class PickDateAdapter extends NativeDateAdapter {

  format(date: Date, displayFormat: Object): string {
    if (displayFormat === PICK_FORMATS.display.monthYearLabel) {
      // "formatDate" does not fit because it adds declination to the month
      return dayjs(date).format('MMMM YYYY');
    } else {
      return formatDate(date,'dd.MM.yyyy',this.locale);
    }
  }

  getFirstDayOfWeek(): number {
    return 1;
  }
}
